import { useAppDispatch, useAppSelector } from "@/shared/hooks";
import { setZoom, setTheme, toggleImages } from "../slice";
import { selectZoom, selectTheme, selectShowImages } from "../selectors";
import type { ZoomLevel, Theme } from "../types";

export function useAccessibilityControls() {
  const dispatch = useAppDispatch();
  const zoom = useAppSelector(selectZoom);
  const theme = useAppSelector(selectTheme);
  const showImages = useAppSelector(selectShowImages);

  function setZoomLevel(level: ZoomLevel) {
    dispatch(setZoom(level));
  }

  function setThemeOption(option: Theme) {
    dispatch(setTheme(option));
  }

  function toggleShowImages() {
    dispatch(toggleImages());
  }

  return { zoom, setZoomLevel, theme, setThemeOption, showImages, toggleShowImages };
}
